import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col max-h-screen w-full gap-7 overflow-y-scroll pb-32" }
const _hoisted_2 = { class: "mx-auto" }
const _hoisted_3 = { class: "flex justify-center pb-16 mb-[60px] overflow-y-scroll" }
const _hoisted_4 = { class: "flex gap-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Exit", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Submit", -1)
const _hoisted_7 = {
  key: 1,
  class: "px-10 py-3 h-12 font-bold w-full dark:text-primary-violet"
}

import { onMounted, computed, ref, watch } from "vue"
  import { useRoute, useRouter } from "vue-router"
  import { useCultureKitStore } from "@/store/cultureKit"
  import { modalController, toastController } from "@ionic/vue"
  import jwt from "@/utils/jwt"

  // components
  import WbButton from "@/components/template/buttonTemplate.vue"
  import QuestionContainer from "@/components/culture-kit/employee-ambassadorship/QuestionContainer.vue"
  import BannerTemplate from "@/components/culture-kit/BannerTemplate.vue"
  import verifySubmit from "@/components/culture-kit/verifySubmit.vue"

  // image
  import BannerImage from "@/assets/images/question/ambassadorship-banner.png"

  // initialize stores ang generate nbf
  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeAmbassadorship',
  setup(__props) {

  const store = useCultureKitStore()
  const route = useRoute()
  const router = useRouter()
  const nbf = jwt.generateNBF()

  // initializations
  const confirmation = ref(false)
  const banner = computed(() => ({
    title: "Congratulations! You are chosen to be voice of the company!",
    topicList: store.labels,
    image: BannerImage,
  }))

  /**
   * submit answer
   */
  const onSubmit = async () => {
    store.status = "active"
    if (store.answer_id.length) await store.updateAnswer(nbf, route.query.token as string, "ambassadorship")
    else await store.saveAnswer(nbf, route.query.token as string, "ambassadorship")
    await store.retrieveQuestions(route.params.slug as string, route.query.token as string)
    confirmation.value = false
    const toast = await toastController.create({
      message: "Answers successfully submitted!",
      duration: 1500,
      position: "top",
      color: "success",
    })
    await toast.present()
    setTimeout(() => {
      window.location.href = "/"
    }, 1000)
  }

  // exits questionaire and redirects to homepage
  const exit = () => {
    window.location.href = "/"
  }

  // opens confirmation modal
  const openModal = async () => {
    const modal = await modalController.create({
      component: verifySubmit,
      initialBreakpoint: 0.75,
      breakpoints: [0.5, 1],
    })
    modal.present()
  }

  /**
   * retrieve data
   */
  onMounted(async () => {
    if (!route.params.slug || !route.query.token) router.push("/")
    else {
      await store.retrieveQuestions(route.params.slug as string, route.query.token as string)
    }
  })

  watch(
    () => router.currentRoute.value.query.submit,
    (value) => {
      if (value === "true") onSubmit()
    }
  )

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BannerTemplate, { data: _unref(banner) }, null, 8, ["data"]),
      _createVNode(QuestionContainer),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(WbButton, {
            class: "bg-white text-primary-violet shadow-xl px-10 h-12 w-full",
            type: "default",
            "native-type": "button",
            onClick: exit
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          (_unref(store).status === 'draft')
            ? (_openBlock(), _createBlock(WbButton, {
                key: 0,
                id: "ea-answers",
                class: "px-10 h-12 w-full",
                type: "primary",
                "native-type": "button",
                onClick: openModal
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, "Submitted"))
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _unref(store).labels.length]
  ])
}
}

})